import { AfterViewInit, EventEmitter } from '@angular/core';
var AfterViewInitDirective = /** @class */ (function () {
    function AfterViewInitDirective() {
        this.afterViewInit = new EventEmitter();
    }
    AfterViewInitDirective.prototype.ngAfterViewInit = function () {
        this.afterViewInit.emit();
    };
    return AfterViewInitDirective;
}());
export { AfterViewInitDirective };
//# sourceMappingURL=after-view-init.directive.js.map